
const Footer = () => {
  const quickLinks = [
    { name: "Home", href: "#home" },
    { name: "Solar Plans", href: "#plans" },
    { name: "Benefits", href: "#benefits" },
    { name: "How It Works", href: "#" },
    { name: "Contact", href: "#contact" }
  ];

  const services = [
    "Residential Solar Installation",
    "Commercial Solar Solutions",
    "Solar Panel Maintenance",
    "Government Subsidy Assistance",
    "Solar Financing & EMI"
  ];

  const socialLinks = [
    { icon: "ri-facebook-fill", href: "#", color: "hover:text-blue-500" },
    { icon: "ri-twitter-fill", href: "#", color: "hover:text-blue-400" },
    { icon: "ri-instagram-line", href: "#", color: "hover:text-pink-500" },
    { icon: "ri-linkedin-fill", href: "#", color: "hover:text-blue-600" },
    { icon: "ri-youtube-fill", href: "#", color: "hover:text-red-500" }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-6">
            <img src="/src/images/logo.png" alt="logo" className="w-12 h-12 rounded-full" />

              <div>
                <h3 className="text-xl font-bold" style={{ fontFamily: 'Pacifico, serif' }}>
                  Bharat Batteries & Solar
                </h3>
                <p className="text-xs text-emerald-400 font-medium">PM Surya Ghar Yojana 2025</p>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed mb-6">
              India's trusted solar partner, helping families achieve energy independence through 
              premium solar solutions and government subsidies under PM Surya Ghar Yojana 2025.
            </p>
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className={`w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center transition-all duration-300 ${social.color} hover:scale-110 cursor-pointer`}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-emerald-400">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-300 hover:text-emerald-400 transition-colors duration-300 cursor-pointer flex items-center group"
                  >
                    <i className="ri-arrow-right-s-line mr-2 group-hover:translate-x-1 transition-transform duration-300"></i>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-emerald-400">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index} className="text-gray-300 flex items-start">
                  <i className="ri-check-line text-emerald-400 mr-2 mt-1 flex-shrink-0"></i>
                  <span className="text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-emerald-400">Contact Information</h4>
            <div className="space-y-4">
              <div className="flex items-start">
                <div className="w-10 h-10 bg-emerald-600/20 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-phone-line text-emerald-400"></i>
                </div>
                <div>
                  <div className="text-white font-semibold">Call Us</div>
                  <div className="text-gray-300 text-sm">7496038344</div>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="w-10 h-10 bg-blue-600/20 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-mail-line text-blue-400"></i>
                </div>
                <div>
                  <div className="text-white font-semibold">Email</div>
                  <div className="text-gray-300 text-sm">info@bharatsolarindia.com</div>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-amber-600/20 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-map-pin-line text-amber-400"></i>
                </div>
                <div>
                  <div className="text-white font-semibold">Service Area</div>
                  <div className="text-gray-300 text-sm">All across Haryana</div>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-10 h-10 bg-purple-600/20 rounded-lg flex items-center justify-center mr-3 flex-shrink-0">
                  <i className="ri-time-line text-purple-400"></i>
                </div>
                <div>
                  <div className="text-white font-semibold">Working Hours</div>
                  <div className="text-gray-300 text-sm">Mon-Sat: 10AM-5PM</div>
                  <div className="text-gray-300 text-sm">Sunday: Closed</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Newsletter Section */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-6 py-8">
          <div className="bg-gradient-to-r from-emerald-600/10 to-amber-500/10 rounded-2xl p-8 text-center">
            <h3 className="text-2xl font-bold mb-4">Stay Updated with Solar News</h3>
            <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
              Get the latest updates on government subsidies, solar technology, and exclusive offers 
              delivered straight to your inbox.
            </p>
            <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email address"
                className="flex-1 px-4 py-3 bg-gray-800 border border-gray-700 rounded-xl text-white placeholder-gray-400 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-colors text-sm"
              />
              <button
                type="submit"
                className="bg-gradient-to-r from-emerald-600 to-amber-500 text-white px-6 py-3 rounded-xl font-semibold hover:from-emerald-700 hover:to-amber-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              © 2025 Bharat Batteries & Solar. All rights reserved. | PM Surya Ghar Yojana 2025 Authorized Partner
            </div>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer">
                Terms of Service
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                className="text-gray-400 hover:text-emerald-400 text-sm transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
